import info from '@assets/icons/info.svg';
import { TaCard } from '@components/shared/TaCard/TaCard';
import CustomTooltip from '@components/tooltip/tooltip';
import { useDashboardStore, useFetchSpecialistDashboard } from '@features/dashboard/store';
import { useAppbarTitle } from '@hooks/useAppbarTitle';
import useLanguageNavigate from '@hooks/useLanguageNavigate';
import { usePageTitle } from '@hooks/usePageTitle';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import FeedOutlinedIcon from '@mui/icons-material/FeedOutlined';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useUsersStore } from 'services/users';
import { Analytics } from './components/Analytics';
import { ProfileCode } from './components/ProfileCode';
import { RequestsAndOffers } from './components/RequestsAndOffers';
import { useEffect } from 'react';

export const DashboardSpecialistPage = () => {
	const { navigateWithLanguage } = useLanguageNavigate();
	const { t } = useTranslation();
	const { specialistData } = useDashboardStore();
	const { language } = useParams();
	const { user } = useUsersStore();

	const specialist = specialistData?.data;

	usePageTitle(t('dashboardPage'));
	useAppbarTitle('dashboardPage');

	// Get the refresh function but don't call it directly
	const { refresh: refreshSpecialistDashboard } = useFetchSpecialistDashboard();

	// Use useEffect to control when to fetch data
	useEffect(() => {
		// Only fetch if we don't already have data or if user changes
		if (!specialistData || !specialist) {
			console.log('Fetching specialist dashboard data');
			refreshSpecialistDashboard();
		}
	}, [specialistData, specialist, refreshSpecialistDashboard, user?.id]);

	const handleClick = () => {
		if (language === 'ka') {
			window.open(
				'https://airtable.com/apphcW37IxsT5lZlp/shrOR7AGDSbOW8JWk/tblua0fkbEoKmCLnd/viwtxuGEdFJy14WHg',
				'_blank'
			);
		} else {
			window.open(
				'https://airtable.com/apphcW37IxsT5lZlp/shrOR7AGDSbOW8JWk/tblXwUI5OlS4qbuBB/viwRgPQg0rUcjtKBu',
				'_blank'
			);
		}
	};

	return (
		<div className="w-full pb-6 max-w-[1440px] mx-auto px-5 flex items-center justify-start md:justify-center flex-col">
			<div className="w-full">
				<RequestsAndOffers data={specialist} />
			</div>
			<div className="w-full bg-light my-5 md:h-[1px] h-0" />
			<div className="md:hidden flex flex-col gap-6 mb-5 w-full">
				<div
					className="shadow-lg relative flex justify-center items-center w-full bg-white border-l-[10px] border-l-primary rounded-[7px] text-dark font-bold text-base font-roboto py-6"
					onClick={() => navigateWithLanguage('/specialist/view-offers')}
				>
					{t('requestsOffers')}
					<div className="absolute right-4">
						<KeyboardArrowRightIcon />
					</div>
				</div>
				<div
					className="shadow-lg relative flex justify-center items-center w-full bg-primary border-l-[10px] border-l-[#038877] rounded-[7px] text-white font-bold text-base font-roboto py-6"
					// onClick={() => navigateWithLanguage('/specialist/monitoring/offers')}
				>
					{t('ongoingMonitoring')}
					{/* <span className="ml-[4px]">(1)</span> */}
					<div className="absolute right-4">
						<KeyboardArrowRightIcon />
					</div>
				</div>
			</div>
			<div className="grid md:grid-cols-2 gap-5 w-full md:max-h-[364px]">
				<Analytics specialist={specialist} />
				{/* Chat widget hidden for specialists */}
				{/* <div className="hidden md:block w-full">
					<ChatCard />
				</div> */}
				<div className="w-full gap-5 flex flex-col">
					<div className="md:h-[75%]">
						<ProfileCode profile={user} />
					</div>
					<div className="md:h-[25%]">
						<TaCard className="p-[10px] h-full flex justify-center items-center">
							<CustomTooltip
								placement="top"
								title={
									<div className="flex w-full gap-[10px] pointer">
										<img src={info} alt="" />
										<p className="roboto-regular text-[16px] leading-[140%]">
											{t('listedPesticides')}
										</p>
									</div>
								}
							>
								<div
									onClick={handleClick}
									className="flex justify-center items-center gap-[10px] cursor-pointer"
								>
									<FeedOutlinedIcon className="text-primary" />
									<p className="text-dark font-[500] text-[16px] uppercase">
										{t('registeredPesticides')}
									</p>
									<ArrowForwardOutlinedIcon className="text-secondary" />
								</div>
							</CustomTooltip>
						</TaCard>
					</div>
				</div>
			</div>
		</div>
	);
};
